import get from 'lodash/fp/get'

export const getNotifications = get('notifications')
